export const SET_STRIPING = 'SET_STRIPING';
export const SET_INTERFERENCE = 'SET_INTERFERENCE';
